<template>
  <div class="page-content">
    <!-- 线索详情卡片 -->
    <div class="detail-card">
      <div class="detail-body">
        <div class="detail-row">
          <div class="detail-item">
            <span class="detail-label">区域：</span>
            <span class="detail-value">{{ selectDictLabel(dicts.consultation_area.value, consultationBookDetail.area) }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">就近校区：</span>
            <span class="detail-value">{{ consultationBookDetail.nearbySchoolName }}</span>
          </div>
        </div>
        <div class="detail-row">
          <div class="detail-item">
            <span class="detail-label">联系人名称：</span>
            <span class="detail-value">{{ consultationBookDetail.contactName }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">年级：</span>
            <span class="detail-value">{{ selectDictLabel(dicts.grade_list.value, consultationBookDetail.grade) }}</span>
          </div>
        </div>
        <div class="detail-row">
          <div class="detail-item">
            <span class="detail-label">手机号：</span>
            <span class="detail-value clickable" @click="dialPhone(consultationBookDetail.phone)">{{
              consultationBookDetail.phone }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">意向科目：</span>
            <span class="detail-value">{{ consultationBookDetail.intentionSubjectName || '-' }}</span>
          </div>
        </div>
        <div class="detail-row">
          <div class="detail-item">
            <span class="detail-label">学生类型：</span>
            <span class="detail-value">{{ selectDictLabel(dicts.student_type.value, consultationBookDetail.studentType) }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">线索质量：</span>
            <span class="detail-value">{{ selectDictLabel(dicts.common_level.value, consultationBookDetail.clueQuality) }}</span>
          </div>
        </div>
        <div class="detail-row">
          <div class="detail-item">
            <span class="detail-label">来源：</span>
            <span class="detail-value">{{ selectDictLabel(dicts.consultation_source.value, consultationBookDetail.source) }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">状态：</span>
            <span class="detail-value">{{ selectDictLabel(dicts.consultation_status.value, consultationBookDetail.status) }}</span>
          </div>
        </div>
        <div class="detail-row">
          <div class="detail-item">
            <span class="detail-label">其他联系方式：</span>
            <span class="detail-value">{{ consultationBookDetail.otherConcatMethods }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">线索分类：</span>
            <span class="detail-value">{{ selectDictLabel(dicts.marketing_activity_type.value, consultationBookDetail.type) }}</span>
          </div>
        </div>
        <div class="detail-row">
          <div class="detail-item full-width">
            <span class="detail-label">意向服务：</span>
            <span class="detail-value">{{ selectDictLabel(dicts.service_type.value, consultationBookDetail.services, ',') }}</span>
          </div>
        </div>
        <div class="detail-row">
          <div class="detail-item full-width">
            <span class="detail-label">创建时间：</span>
            <span class="detail-value">{{ consultationBookDetail.createTime }}</span>
          </div>
        </div>
        <div class="detail-row">
          <div class="detail-item full-width">
            <span class="detail-label">备注：</span>
            <span class="detail-value">{{ consultationBookDetail.remark || '-' }}</span>
          </div>
        </div>
        <div class="detail-row" v-for="item in dynamicFieldItems" :key="item.fieldKey || item.label">
          <div class="detail-item full-width">
            <span class="detail-label">{{ item.label }}：</span>
            <span class="detail-value">{{ item.displayValue || '-' }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 跟进记录列表 -->
    <div class="section-title">跟进记录</div>
    <div class="records-container">
      <a-card style="width: 100%" size="small" v-for="item in consulationBookRecordList"
        :key="item.consultationRecordId" class="record-card">
        <div class="cell-row">
          <Cell label="跟进人" :value="item.followUserName" />
          <Cell label="跟进时间" :value="item.followTime" />
        </div>
        <div class="cell-row">
          <Cell label="跟进方式" :value="selectDictLabel(dicts.follow_up_method.value, item.followType)" />
          <Cell label="跟进阶段" :value="selectDictLabel(dicts.follow_up_phase.value, item.followStage)" />
        </div>
        <Cell label="跟进内容" :value="item.followContent" />
        <!-- 附件展示 -->
        <div v-if="item.annex" class="annex-section">
          <span class="annex-label">附件：</span>
          <div class="annex-list">
            <img v-for="(url, index) in splitAnnexUrls(item.annex)" :key="index" :src="url" class="annex-image"
              :alt="`附件${index + 1}`" @click="handlePreviewImage(url)" />
          </div>
        </div>
      </a-card>
    </div>

    <div class="page-content-footer">
      <a-button v-if="consultationBookDetail.followUserId" type="primary" style="width: 100%;"
        @click="goToAddFollowRecord">添加跟进记录</a-button>
    </div>


  </div>

  <!-- 图片预览组件 -->
  <van-image-preview v-model:show="showPreview" :images="previewImages" :start-position="previewStartIndex"
    :show-index="true" :closeable="true" />
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { getConsultationRecords, getConsultationBookDetail } from '@/api/consultationBook'
import Cell from '@/component/cell.vue'
import { ensureWecomLogin } from '@/utils/wecomAuth'
import { ImagePreview as VanImagePreview } from 'vant'
import { useDict, selectDictLabel } from '@/utils/dict'

const route = useRoute()
const router = useRouter()
const dicts = useDict(
  'consultation_source',
  'consultation_area',
  'grade_list',
  'student_type',
  'common_level',
  'course_subject',
  'consultation_status',
  'follow_up_method',
  'follow_up_phase',
  'service_type',
  'marketing_activity_type'
)

const consultationBookId = ref()
const consultationBookDetail = ref({})
const dynamicFieldItems = ref([])
const consulationBookRecordList = ref([])
const showPreview = ref(false)
const previewImages = ref([])
const previewStartIndex = ref(0)

onMounted(async () => {
  consultationBookId.value = route.query.state || route.query.consultationBookId
  await ensureWecomLogin(route.query.code)
  initData()
})

async function initData() {
  await dicts.loadDicts()
  loadConsultationBookDetail()
  loadConsulationBookRecord()
}

function loadConsultationBookDetail() {
  getConsultationBookDetail(consultationBookId.value).then(response => {
    if (!response) return
    consultationBookDetail.value = response
    dynamicFieldItems.value = parseDynamicFields(response.dynamicFields)
    // 使用 selectDictLabel 处理意向科目（多选）
    if (consultationBookDetail.value.intentionSubject) {
      consultationBookDetail.value.intentionSubjectName = selectDictLabel(
        dicts.course_subject.value,
        consultationBookDetail.value.intentionSubject,
        ','
      )
    }
  })
}

function parseDynamicFields(raw) {
  if (!raw) return []
  try {
    const parsed = JSON.parse(raw)
    if (!Array.isArray(parsed)) return []
    return parsed.map(item => {
      const value = item && item.value
      const fallback = Array.isArray(value) ? value.join('、') : value
      return {
        fieldKey: item && item.fieldKey ? item.fieldKey : '',
        label: item && (item.label || item.fieldKey) ? (item.label || item.fieldKey) : '未命名字段',
        displayValue: item && item.displayValue ? item.displayValue : (fallback || '-')
      }
    })
  } catch (error) {
    return []
  }
}

function loadConsulationBookRecord() {
  getConsultationRecords(consultationBookId.value).then(response => {
    consulationBookRecordList.value = response
  })
}

function goToAddFollowRecord() {
  router.push({
    path: '/consultationBook/addFollowRecord',
    query: { consultationBookId: consultationBookId.value }
  })
}

function splitAnnexUrls(annexStr) {
  if (!annexStr) return []
  const cleanedStr = annexStr.replace(/^[\s"`]+|[\s"`]+$/g, '')
  return cleanedStr.split(',').filter(url => url.trim())
}

function handlePreviewImage(url) {
  const currentRecord = consulationBookRecordList.value.find(record => {
    if (!record.annex) return false
    return splitAnnexUrls(record.annex).includes(url)
  })

  if (currentRecord) {
    previewImages.value = splitAnnexUrls(currentRecord.annex)
    previewStartIndex.value = previewImages.value.indexOf(url)
    showPreview.value = true
  }
}

function dialPhone(phone) {
  if (phone) {
    window.location.href = `tel:${phone}`
  }
}
</script>

<style scoped>
.page-content {
  padding: 12px 12px 70px 12px;
  /* 增加底部内边距，为固定按钮留出空间 */
  font-size: 14px;
  color: #333;
  min-height: 100vh;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  background-color: #f8f9fa;
  overflow-x: hidden;
}

/* 详情卡片样式 */
.detail-card {
  background-color: white;
  border-radius: 10px;
  padding: 12px;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: box-shadow 0.3s ease;
}

.detail-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
}

.detail-header {
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;
}

.detail-title {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.detail-body {
  display: flex;
  flex-direction: column;
}

.detail-row {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 8px;
}

.detail-item {
  flex: 1;
  min-width: calc(50% - 6px);
  margin-right: 12px;
  margin-bottom: 4px;
  padding: 2px 0;
}

.detail-item.full-width {
  flex: 100%;
  min-width: 100%;
  margin-right: 0;
}

.detail-item:last-child {
  margin-right: 0;
}

.detail-label {
  font-size: 13px;
  color: #777;
  margin-right: 6px;
  display: inline-block;
  vertical-align: middle;
  min-width: 55px;
}

.detail-value {
  font-size: 13px;
  color: #222;
  font-weight: 500;
  display: inline-block;
  vertical-align: middle;
  word-break: break-word;
  line-height: 1.4;
}

.detail-value.clickable {
  color: #1890ff;
  cursor: pointer;
}

/* 跟进记录标题 */
.section-title {
  font-size: 17px;
  font-weight: 600;
  color: #333;
  margin: 16px 0 10px 0;
}

/* 跟进记录滚动容器 */
.records-container {
  flex: 1;
  overflow-y: auto;
  margin-bottom: 8px;
}

/* 跟进记录卡片样式 */
.record-card {
  margin-bottom: 10px;
}

.cell-row {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.cell-row .cell {
  flex: 1;
  min-width: calc(50% - 10px);
}

.record-card .cell {
  padding: 5px 10px;
}

/* 底部按钮固定定位 */
.page-content-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 12px;
  background-color: transparent;
  /* 设置透明背景 */
  /* 移除阴影 */
  z-index: 10;
  box-sizing: border-box;
  display: flex;
  /* 使用flex布局 */
  justify-content: center;
  /* 水平居中 */
  align-items: center;
  /* 垂直居中 */
}

.mt-10 {
  margin-top: 12px;
}

/* 跟进记录卡片样式 */
:deep(.ant-card) {
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  margin-bottom: 8px;
}

/* 附件展示样式 */
.annex-section {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;
}

.annex-label {
  font-size: 13px;
  color: #777;
  margin-bottom: 8px;
  display: block;
}

.annex-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.annex-image {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 4px;
  cursor: pointer;
  transition: transform 0.2s;
}

.annex-image:hover {
  transform: scale(1.05);
}



:deep(.ant-card-small > .ant-card-head) {
  padding: 12px 16px;
  border-bottom: 1px solid #f5f5f5;
}

:deep(.ant-card-small > .ant-card-body) {
  padding: 16px;
}

/* 底部按钮样式 */
.page-content-footer {
  padding: 20px 0;
}

:deep(.ant-btn-primary) {
  background-color: #1890ff;
  border-color: #1890ff;
  border-radius: 8px;
  height: 44px;
  font-size: 16px;
  font-weight: 500;
  box-shadow: 0 2px 8px rgba(24, 144, 255, 0.3);
  transform: scale(0.8);
  /* 缩小按钮到80% */
  transform-origin: center;
  /* 以中心为原点缩放 */
  transition: all 0.3s ease;
}

:deep(.ant-btn-primary:hover) {
  background-color: #40a9ff;
  border-color: #40a9ff;
  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.4);
}

/* 跟进记录对话框样式 */
:deep(.van-dialog) {
  border-radius: 12px;
}

:deep(.van-dialog__header) {
  padding: 16px 24px 12px;
}

:deep(.van-dialog__title) {
  font-size: 18px;
  font-weight: 600;
}

:deep(.van-dialog__body) {
  padding: 0 24px 16px;
}

:deep(.van-field) {
  margin-top: 12px;
}

:deep(.van-field__label) {
  font-weight: 500;
}

:deep(.van-dialog__footer) {
  padding: 12px 24px;
  border-top: 1px solid #f5f5f5;
}

:deep(.van-button--primary) {
  background-color: #1890ff;
  border-color: #1890ff;
}

:deep(.van-button--primary:hover) {
  background-color: #40a9ff;
  border-color: #40a9ff;
}

/* 响应式设计 - 保持两列布局适配不同手机尺寸 */
@media (max-width: 414px) {
  .detail-row {
    margin-bottom: 4px;
  }

  .detail-item {
    min-width: calc(50% - 5px);
    /* 调整间距确保两列 */
    margin-right: 10px;
    margin-bottom: 4px;
    padding: 2px 0;
  }

  .detail-item:nth-child(2n) {
    margin-right: 0;
  }

  .detail-label {
    min-width: 50px;
    /* 稍微缩小标签宽度适应小屏幕 */
    font-size: 12px;
    /* 小屏幕下标签文字稍小 */
  }

  .detail-value {
    font-size: 12px;
    /* 小屏幕下值文字稍小 */
  }
}

/* 超小屏幕设备的额外适配 */
@media (max-width: 320px) {
  .detail-item {
    min-width: calc(50% - 4px);
    margin-right: 8px;
  }

  .detail-label {
    min-width: 45px;
    font-size: 11px;
  }

  .detail-value {
    font-size: 11px;
  }
}
</style>
